import { useQuestSubType } from './useQuestSubType';
import { SIMPLE, SIMPLE_SECRET_WORD } from '../../../constants/tasksTypes';
import { useOpen } from '../../useOpen';

export const useClickOnExtraButton = ({ quest }) => {
  const { type, button_link } = quest;
  const subType = useQuestSubType({ quest });

  const open = useOpen();

  const handlerByType = {
    [SIMPLE]() {
      if (subType === SIMPLE_SECRET_WORD && button_link) {
        open(button_link);
      }
    },
  };

  return handlerByType[type];
};
